import { render } from "./SignUpInviteUsers.vue?vue&type=template&id=074ed688&scoped=true"
import script from "./SignUpInviteUsers.vue?vue&type=script&lang=js"
export * from "./SignUpInviteUsers.vue?vue&type=script&lang=js"

import "./SignUpInviteUsers.vue?vue&type=style&index=0&id=074ed688&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074ed688"]])

export default __exports__